import { isBrowser } from "^/utils/isBrowser";

export const richSnippetsJSONOrganization = (url, logoUrl) => {
  const data = {
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Hochschule Heilbronn",
    url,
    logo: logoUrl,
    sameAs: [
      "https://www.facebook.com/hochschule.heilbronn/",
      "https://www.youtube.com/user/HochschuleHeilbronn",
      "https://www.instagram.com/hochschule_heilbronn/",
    ],
  };

  return JSON.stringify(data);
};

export const richSnippetsJSONCourse = (course, mapping) => {
  const title = course.get("title");
  const description = course.get("courseDescription");
  const location = mapping[course.get("location")];
  const courseForm = mapping[course.get("form")];
  const courseLangs = course.get("lang").map((lang) => mapping[lang]) || [];
  const courseWorkload = course.get("courseWorkload");
  const url = isBrowser && window.location.href;

  const data = {
    "@context": "http://schema.org/",
    "@type": "schema:Course",
    title,
    name: title,
    description: title || description,
    url,
    provider: {
      "@type": "EducationalOrganization",
      name: "Hochschule Heilbronn",
    },
    hasCourseInstance: {
      "@type": "CourseInstance",
      courseMode: "onsite",
      courseWorkload: courseWorkload || "P3M",
      location,
      inLanguage: courseLangs,
      category: courseForm,
    },
    offers: {
      "@type": "Offer",
      price: "Free",
      priceCurrency: "EUR",
      availability: "http://schema.org/InStock",
      category: "course",
    },
  };
  return JSON.stringify(data);
};
